"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * canned-messages-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertCannedMessagesApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ExpertCannedMessagesApi extends runtime.BaseAPI {
    /**
     */
    createRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling create.');
            }
            if (requestParameters.expertCannedMessages === null || requestParameters.expertCannedMessages === undefined) {
                throw new runtime.RequiredError('expertCannedMessages', 'Required parameter requestParameters.expertCannedMessages was null or undefined when calling create.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ExpertCannedMessagesToJSON(requestParameters.expertCannedMessages),
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     */
    create(expertId, expertCannedMessages) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRaw({ expertId: expertId, expertCannedMessages: expertCannedMessages });
            return yield response.value();
        });
    }
    /**
     */
    createCannedMessageSuggestionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling createCannedMessageSuggestion.');
            }
            if (requestParameters.createCannedMessageSuggestionPayload === null || requestParameters.createCannedMessageSuggestionPayload === undefined) {
                throw new runtime.RequiredError('createCannedMessageSuggestionPayload', 'Required parameter requestParameters.createCannedMessageSuggestionPayload was null or undefined when calling createCannedMessageSuggestion.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/suggestion`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CreateCannedMessageSuggestionPayloadToJSON(requestParameters.createCannedMessageSuggestionPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesSuggestionsFromJSON(jsonValue));
        });
    }
    /**
     */
    createCannedMessageSuggestion(expertId, createCannedMessageSuggestionPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCannedMessageSuggestionRaw({ expertId: expertId, createCannedMessageSuggestionPayload: createCannedMessageSuggestionPayload });
            return yield response.value();
        });
    }
    /**
     */
    createCategoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling createCategory.');
            }
            if (requestParameters.createCategoryPayload === null || requestParameters.createCategoryPayload === undefined) {
                throw new runtime.RequiredError('createCategoryPayload', 'Required parameter requestParameters.createCategoryPayload was null or undefined when calling createCategory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CreateCategoryPayloadToJSON(requestParameters.createCategoryPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    createCategory(expertId, createCategoryPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCategoryRaw({ expertId: expertId, createCategoryPayload: createCategoryPayload });
            return yield response.value();
        });
    }
    /**
     */
    createMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling createMessage.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling createMessage.');
            }
            if (requestParameters.createCannedMessagePayload === null || requestParameters.createCannedMessagePayload === undefined) {
                throw new runtime.RequiredError('createCannedMessagePayload', 'Required parameter requestParameters.createCannedMessagePayload was null or undefined when calling createMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}/message`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CreateCannedMessagePayloadToJSON(requestParameters.createCannedMessagePayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    createMessage(expertId, categoryId, createCannedMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createMessageRaw({ expertId: expertId, categoryId: categoryId, createCannedMessagePayload: createCannedMessagePayload });
            return yield response.value();
        });
    }
    /**
     */
    deleteCannedMessageSuggestionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling deleteCannedMessageSuggestion.');
            }
            if (requestParameters.cannedMessageId === null || requestParameters.cannedMessageId === undefined) {
                throw new runtime.RequiredError('cannedMessageId', 'Required parameter requestParameters.cannedMessageId was null or undefined when calling deleteCannedMessageSuggestion.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/suggestion/{cannedMessageId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"cannedMessageId"}}`, encodeURIComponent(String(requestParameters.cannedMessageId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesSuggestionsFromJSON(jsonValue));
        });
    }
    /**
     */
    deleteCannedMessageSuggestion(expertId, cannedMessageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCannedMessageSuggestionRaw({ expertId: expertId, cannedMessageId: cannedMessageId });
            return yield response.value();
        });
    }
    /**
     */
    deleteCannedMessageSuggestionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling deleteCannedMessageSuggestions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/suggestion`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesSuggestionsFromJSON(jsonValue));
        });
    }
    /**
     */
    deleteCannedMessageSuggestions(expertId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCannedMessageSuggestionsRaw({ expertId: expertId });
            return yield response.value();
        });
    }
    /**
     */
    deleteCategoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling deleteCategory.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling deleteCategory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    deleteCategory(expertId, categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCategoryRaw({ expertId: expertId, categoryId: categoryId });
            return yield response.value();
        });
    }
    /**
     */
    deleteMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling deleteMessage.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling deleteMessage.');
            }
            if (requestParameters.cannedMessageId === null || requestParameters.cannedMessageId === undefined) {
                throw new runtime.RequiredError('cannedMessageId', 'Required parameter requestParameters.cannedMessageId was null or undefined when calling deleteMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}/message/{cannedMessageId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"cannedMessageId"}}`, encodeURIComponent(String(requestParameters.cannedMessageId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    deleteMessage(expertId, categoryId, cannedMessageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteMessageRaw({ expertId: expertId, categoryId: categoryId, cannedMessageId: cannedMessageId });
            return yield response.value();
        });
    }
    /**
     */
    getRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling get.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    get(expertId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRaw({ expertId: expertId });
            return yield response.value();
        });
    }
    /**
     */
    updateCategoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling updateCategory.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling updateCategory.');
            }
            if (requestParameters.updateCategoryPayload === null || requestParameters.updateCategoryPayload === undefined) {
                throw new runtime.RequiredError('updateCategoryPayload', 'Required parameter requestParameters.updateCategoryPayload was null or undefined when calling updateCategory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdateCategoryPayloadToJSON(requestParameters.updateCategoryPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    updateCategory(expertId, categoryId, updateCategoryPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCategoryRaw({ expertId: expertId, categoryId: categoryId, updateCategoryPayload: updateCategoryPayload });
            return yield response.value();
        });
    }
    /**
     */
    updateMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling updateMessage.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling updateMessage.');
            }
            if (requestParameters.cannedMessageId === null || requestParameters.cannedMessageId === undefined) {
                throw new runtime.RequiredError('cannedMessageId', 'Required parameter requestParameters.cannedMessageId was null or undefined when calling updateMessage.');
            }
            if (requestParameters.updateCannedMessagePayload === null || requestParameters.updateCannedMessagePayload === undefined) {
                throw new runtime.RequiredError('updateCannedMessagePayload', 'Required parameter requestParameters.updateCannedMessagePayload was null or undefined when calling updateMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}/message/{cannedMessageId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"cannedMessageId"}}`, encodeURIComponent(String(requestParameters.cannedMessageId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdateCannedMessagePayloadToJSON(requestParameters.updateCannedMessagePayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    updateMessage(expertId, categoryId, cannedMessageId, updateCannedMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateMessageRaw({ expertId: expertId, categoryId: categoryId, cannedMessageId: cannedMessageId, updateCannedMessagePayload: updateCannedMessagePayload });
            return yield response.value();
        });
    }
    /**
     */
    updateMessageUsageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling updateMessageUsage.');
            }
            if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
                throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling updateMessageUsage.');
            }
            if (requestParameters.cannedMessageId === null || requestParameters.cannedMessageId === undefined) {
                throw new runtime.RequiredError('cannedMessageId', 'Required parameter requestParameters.cannedMessageId was null or undefined when calling updateMessageUsage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/category/{categoryId}/message/{cannedMessageId}/usage`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"cannedMessageId"}}`, encodeURIComponent(String(requestParameters.cannedMessageId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    updateMessageUsage(expertId, categoryId, cannedMessageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateMessageUsageRaw({ expertId: expertId, categoryId: categoryId, cannedMessageId: cannedMessageId });
            return yield response.value();
        });
    }
    /**
     */
    updateMetadataRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling updateMetadata.');
            }
            if (requestParameters.updateExpertCannedMessagesMetadataPayload === null || requestParameters.updateExpertCannedMessagesMetadataPayload === undefined) {
                throw new runtime.RequiredError('updateExpertCannedMessagesMetadataPayload', 'Required parameter requestParameters.updateExpertCannedMessagesMetadataPayload was null or undefined when calling updateMetadata.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", ["require-access-to-specific-expert"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/v1/expertCannedMessages/{expertId}/metadata`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdateExpertCannedMessagesMetadataPayloadToJSON(requestParameters.updateExpertCannedMessagesMetadataPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertCannedMessagesFromJSON(jsonValue));
        });
    }
    /**
     */
    updateMetadata(expertId, updateExpertCannedMessagesMetadataPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateMetadataRaw({ expertId: expertId, updateExpertCannedMessagesMetadataPayload: updateExpertCannedMessagesMetadataPayload });
            return yield response.value();
        });
    }
}
exports.ExpertCannedMessagesApi = ExpertCannedMessagesApi;
